import { render, staticRenderFns } from "./NewEnvelopeMobileModal.vue?vue&type=template&id=448a30a7&lang=pug"
import script from "./NewEnvelopeMobileModal.vue?vue&type=script&lang=js"
export * from "./NewEnvelopeMobileModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports